import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import NavigationsGrid from '../components/Grid';
import { NavigationProvider } from '../store';

import NavigationFormLayout from './Form';

export default function NavigationsGridLayout() {
  return <NavigationProvider>
    <NavigationsGrid />
    <Router>
      <PrivateRoute path="/cms/settings/navigations/add" component={NavigationFormLayout} />
    </Router>
  </NavigationProvider>;
}
